// extracted by mini-css-extract-plugin
module.exports = {"form":"EnquiryDialog_form__UKccz","modalTitle":"EnquiryDialog_modalTitle__8qAuP"};